/* global angular */

angular.module('gc.progress-bar', [])
.directive('progressBar', function () {
  'use strict';
  return {
    restrict: 'E',
    scope: {
      value: '=',
      unit: '@'
    },
    template: '<div class="gc-progress-bar">' +
    '  <div class="progress-div">' +
    '    <div class="background-div"></div>' +
    '    <div style="position: absolute; left: 0; bottom: 0; background: red; width: {{value}}%; height: 2px;"></div>' +
    '  </div>' +
    '  <div class="right-percent">' +
    '    <p>{{value}}{{unit}}</p>' +
    '  </div>' +
    '</div>'
  };
});